import { render, staticRenderFns } from "./retrievalTask.vue?vue&type=template&id=40a937d2"
import script from "./retrievalTask.vue?vue&type=script&lang=js"
export * from "./retrievalTask.vue?vue&type=script&lang=js"
import style0 from "./retrievalTask.vue?vue&type=style&index=0&id=40a937d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports